import React from "react";
import { reduxForm } from "redux-form";

import Button from "components/atoms/button/index.jsx";
import ValidatePromotionCode from "components/molecules/promotionCode/Validate";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormTextField from "components/molecules/formTextField/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";
import validate from "components/organisms/buyForm/validate.jsx";
import { currency } from "helpers/format";

class PaymentInformationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coupon: null,
    };

    this.applyDiscount = this.applyDiscount.bind(this);
  }

  applyDiscount(coupon) {
    this.setState({
      coupon,
    });
    this.props.applyDiscount(coupon);
  }

  render() {
    const { coupon } = this.state;

    return (
      <form onSubmit={this.props.handleSubmit}>
        <h3>Descuento online</h3>

        {!coupon && (
          <>
            <ValidatePromotionCode
              onSuccess={this.applyDiscount}
              vehicle={this.props.vehicle}
              defaultCode={sessionStorage.getItem("coupon")}
            />
            <FormFieldset>
              <div className="FormInfo">
                <p>
                  Si no tenés un cupón de descuento, podés omitir este paso.
                </p>
              </div>
            </FormFieldset>
          </>
        )}

        {coupon && (
          <FormFieldset>
            <FormCol first="true">
              <div className="FormInfo">
                <p>
                  <strong>Cupón de descuento {coupon.code} aplicado.</strong>
                  <br />
                  Descuento
                  {coupon.money_discount > 0 && (
                    <span> -{currency(coupon.money_discount)}</span>
                  )}
                  {coupon.percentage_discount > 0 && (
                    <span> -{coupon.percentage_discount}%</span>
                  )}
                </p>
              </div>
            </FormCol>
          </FormFieldset>
        )}

        <FormActions>
          <Button buttonText="Continuar" type="submit" />
        </FormActions>
      </form>
    );
  }
}

export default reduxForm({
  form: "buy",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PaymentInformationForm);
